import { useQuery } from '@tanstack/react-query';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import request from '@teetsh/app/src/utils/request';
import { EDT_KEY } from '@teetsh/app/src/queries/edt/useEDTs';
import { edtDeserializer } from '@teetsh/app/src/queries/edt/serializer';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';

function fetchEDT({
  schoolyearId,
  schoolId,
  edtId,
  tz,
}: {
  schoolyearId: string;
  schoolId: string;
  edtId: string;
  tz: string;
}) {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/emplois-du-temps/${edtId}`;
  return request(requestURL, {
    method: 'GET',
  }).then(edt => edtDeserializer(edt, tz));
}

interface Props {
  enabled: boolean;
  edtId: string;
}

export default function useEDT({ edtId, enabled }: Props) {
  const { schoolyear, school } = useSchoolSchoolyear();
  const user = useUser();
  return useQuery({
    queryKey: [schoolyear.id, school.id, EDT_KEY, edtId],
    queryFn: () =>
      fetchEDT({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        edtId,
        tz: user.location,
      }),

    staleTime: 60 * 1000 * 60,
    enabled,
    refetchOnWindowFocus: false,

    retry: (failCount, err) => {
      if (err?.response?.status === 404) {
        return false;
      }
      return failCount < 4;
    },
  });
}
